export default class extends HTMLElement {


  static get observedAttributes() {
    return ['post_id', 'service','style'];
  }

  constructor() {
    super();
    console.log('Init DSBPost');
    this._settings=false;
    this.uuid = this._createUUID();
    this.post_data = [];
    this.append_content = [];
    this.footer = [];
    this.is_refresh = false
    this._navigationHandler = null;
    this.page_view_settings = false;
    this.registeredListners=[];
    this.registeredDistructorFunctions={};
    this._onEvents={};

  }

  disconnectedCallback()
  {
    this._log('debug','disconnectedCallback','Init');
    for(let distructorFunction in this.registeredDistructorFunctions)
    {
      try
      {
        if(typeof this.registeredDistructorFunctions[distructorFunction] == 'function')
        {
          this.registeredDistructorFunctions[distructorFunction]();
        }
      }
      catch(ex)
      {
        this._log('error','disconnectedCallback','Fatal error removing registeredDistructorFunctions',{ex:ex,registeredDistructorFunctions:this.registeredDistructorFunctions[distructorFunction]});
      }
    }

    for(let i=0;i<this.registeredListners.length;i++)
    {
      try
      {
        if('type' in this.registeredListners[i] && 'object' in this.registeredListners[i])
        {
          switch(this.registeredListners[i].type)
          {
            case "Interval":
              window.clearInterval(this.registeredListners[i].object);
              break;
            case "IntersectionObserver":
              if('disconnect' in this.registeredListners[i].object)
              {
                this.registeredListners[i].object.disconnect();
              }
              else
              {
                this._log('warning','disconnectedCallback','Cannot disconnect',this.registeredListners[i]);
              }
              break;
            default:
              this._log('error','disconnectedCallback','Unknown object type '+this.registeredListners[i].type,this.registeredListners[i]);
              break;
          }
        }
      }
      catch(ex)
      {
        this._log('error','disconnectedCallback','Fatal error',ex,this.registeredListners[i]);
      }

    }

    // Clean out hooks
    let app = window.fw_workbench.getApp();
    if('remove_hook' in app && typeof app.remove_hook == 'function')
    {
      app.remove_hook(this.uuid);
    }

    this.registeredListners=[];
    this._log('debug','disconnectedCallback','End');
  }

  get service() {
      return this.getAttribute('service');
  }

  set service(newValue){
      this.setAttribute('service', newValue);
  }

  get settings() {

    if(typeof this._settings !== 'object')
    {
      this._settings = this.getAttribute('settings');
      if(typeof this._settings !== 'object')
      {
        this._settings = JSON.parse(this._settings);
      }

      if(this._settings==null)
      {
        this._settings={};
      }

      if('fw_workbench' in window && typeof window.fw_workbench.getApp == 'function')
      {
        let app = window.fw_workbench.getApp();
        this._settings = Object.assign(this._settings,app.get_settings_override('dsb-post',{}));
      }
    }
    return this._settings;
  }

  set settings(newValue){
      this.setAttribute('settings', newValue);
  }

  get template_path() {
      return this.getAttribute('template_path');
  }

  set template_path(newValue){
      this.setAttribute('template_path', newValue);
  }

  get post_id() {
      let post_id = this.getAttribute('post_id');
      return post_id;
  }

  async getPostIdEndpoint()
  {
    this._log('debug','getPostIdEndpoint');
    let post_id = this.post_id;
    if(this.service == 'static')
    {
        post_id = 'json_by_id/'+this.post_id;
    }

    let is_loggedin = await this.dsbClient.user.is_loggedin('',false,false);
    this._log('debug','getPostIdEndpoint','is logged in '+is_loggedin);
    if(!is_loggedin)
    {
        post_id = 'public_json_by_id/'+this.post_id;
    }
    return post_id;
  }

  get link_path(){
    return this.service+'/'+this.post_id;
  }

  set post_id(newValue){
      this.setAttribute('post_id', newValue);
  }

  get nav_parent_id() {
      return this.getAttribute('nav_parent_id');
  }

  set nav_parent_id(newValue){
      this.setAttribute('nav_parent_id', newValue);
  }

  get post_uri() {
      return this.getAttribute('post_uri');
  }

  set post_uri(newValue){
      this.setAttribute('post_uri', newValue);
  }

  get img_path() {
      return this.getAttribute('img_path');
  }

  set img_path(newValue){
      this.setAttribute('img_path', newValue);
  }

  get type() {
      return this.getAttribute('type');
  }

  get supports()
  {
    return {"offline":true};
  }

  set type(newValue){
      this.setAttribute('type', newValue);
  }

  setDSBClient(dsbClient){
      this.dsbClient=dsbClient;
  }

  onEvent(name,action){
    if(typeof action == 'function')
    {
      if(!(name in this._onEvents))
      {
        this._onEvents[name]=[];
      }
      this._onEvents[name].push(action);
      return true;
    }
    return false;
  }
  doEvent(name,param='')
  {
    if(name in this._onEvents)
    {
      for(let i=0;i<this._onEvents[name].length;i++)
      {
        if(typeof this._onEvents[name][i] == 'function')
        {
          this._onEvents[name][i](param);
        }
      }
      this._onEvents[name]=[];
    }
  }

  setPostList(list){
      this.postList=list;
  }

  setPostData(data){
      this.post_data=[data];
  }

  reset()
  {
    this.post_data = [];
    this._onEvents = {};
  }

  appendContent(data){
      this.append_content.push(data);
  }

  addFooter(data){
      this.footer.push(data);
  }

  resetFooter(){
      this.footer = [];
  }

  connectedCallback()
  {
    return this._render();
  }


  attributeChangedCallback(name, oldValue, newValue)
  {
    //console.error('attributeChangedCallback..'+name,oldValue,newValue);
  }


  _createUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  _generate_a_post_widget(widget)
  {
    let component = false;
    if(`type` in widget)
    {
        switch(widget.type)
        {
            case "WP_Widget_Text":
                    component = document.createElement("div");
                    component.innerHTML = widget.data;
                break;
            case "Pm_Datastore_Builder_Client_Widget":
                if(`data` in widget)
                {
                    component = document.createElement("dsb-list");
                    component.setDSBClient(this.dsbClient);

                    if(`layout_settings` in widget.data && (widget.data.layout_settings.length > 0))
                    {
                      component.setAttribute(`settings`, widget.data.layout_settings);
                    }
                    else
                    {
                      component.setAttribute(`settings`, JSON.stringify({'show-thumbnail':'left',"layout-grid": "1"}));
                    }

                    if(`query` in widget.data)
                    {
                        if(`query` in widget.data.query)
                        {
                            component.setAttribute(`query`, widget.data.query.query);
                        }
                        if(`type` in widget.data.query)
                        {
                            component.setAttribute(`service`, widget.data.query.type);
                        }
                    }
                    //component.setAttribute(`root_path`, this.layout);
                    component.innerHTML = `<maa-spinner></maa-spinner>`;
                }
                else
                {
                    console.error('.data missing from Pm_Datastore_Builder_Client_Widget');
                }
                break;
            default:
                break;
        }
    }
    return component;
  }

  _generate_post_widgets(post_widgets,body)
  {
    console.debug("Settings post_widgets...");
    let has_widgets = false;
    let cell_count = 5;
    if(`grid` in post_widgets)
    {
        let _post_widgets = document.createElement("div");
        _post_widgets.setAttribute('class','post_widgets');
        for(let i in post_widgets.grid)
        {
            let row_settings = false;
            if((`settings` in post_widgets) && (`rows` in post_widgets.settings))
            {
                if(grid_row in post_widgets.settings.rows)
                {
                    row_settings = post_widgets.settings.rows[grid_row];
                }
            }

            let grid_row = document.createElement("div");
            grid_row.setAttribute('class','post_widgets-row');
            let grid_cell = Array.apply(null, Array(5)).map(function () {});
            delete grid_cell[0];

            for(let ii in grid_cell)
            {
                grid_cell[ii] = document.createElement("div");
                grid_cell[ii].setAttribute('class','post_widgets-item');
                if(!(ii in post_widgets.grid[i]))
                {
                     grid_cell[ii].innerHTML = `&nbsp;`;
                    if(row_settings && (`fill` in row_settings) && (row_settings.fill == 'yes'))
                    {
                         delete grid_cell[ii];
                    }
                }
                else
                {
                    if(`span` in post_widgets.grid[i][ii] && post_widgets.grid[i][ii].span>1)
                    {
                         grid_cell[ii].setAttribute('style','flex-grow:'+post_widgets.grid[i][ii].span);
                         let del_count = (Number(post_widgets.grid[i][ii].span) - 1);
                         let del_start = (Number(ii) + 1);
                         for (let span_i = del_start; span_i < 5; span_i++)
                         {
                            if(del_count<1)
                            {
                                break;
                            }
                            delete grid_cell[span_i];
                            del_count--;
                         }
                    }
                    let thisWidget = this._generate_a_post_widget(post_widgets.grid[i][ii]);
                    if(thisWidget)
                    {
                        grid_cell[ii].innerHTML = ``;
                        grid_cell[ii].append(thisWidget);
                    }
                    else
                    {
                        grid_cell[ii].innerHTML = `&nbsp;`;
                        if(row_settings && (`fill` in row_settings) && (row_settings.fill == 'yes'))
                        {
                                delete grid_cell[ii];
                        }
                    }

                }
            }

            for( let aCell in grid_cell)
            {
                grid_row.append(grid_cell[aCell]);
            }
            _post_widgets.append(grid_row);
            body.append(_post_widgets);
            has_widgets = true;
        }
    }
    return has_widgets;
  }

   _log(type,source,message,data='')
  {
    let _message = 'dsb-app/DSBPOST('+this.service+'/'+this.post_id+')::'+source+'- '+message;
    switch(type)
    {
       case "debug":
         console.debug(_message,data);
        break;
      case "warning":
         console.warn(_message,data);
        break;
      case "error":
         console.error(_message,data);
        break;
      default:
          console.log(_message,data);
    }
  }

  page_view()
  {
    if(this.page_view_settings)
    {
      console.debug('dsb-post: Running page view...');
      // Emit Page scrollIntoView
      window.dispatchEvent(new CustomEvent('dsb-pwa-page_view', {detail:this.page_view_settings}));
    }
  }

  async _refresh()
  {
    this.is_refresh = true;
    this.reset();
    return this._render();
  }

  async _setup_toolbar(settings={})
  {
     if('fw_workbench' in window && 'getApp' in window.fw_workbench)
     {
      if(Array.isArray(this.post_data))
      {
        let post_data = this.post_data[0];
        if('document' in post_data)
        {
          post_data=post_data.document;
        }

        let _this = this;
        let toolbar = {};
        let app = window.fw_workbench.getApp();

        let transient_modal__close__function=async function(done_function){
         let wrapper_element = document.createElement("div");
         wrapper_element.style = 'position:absolute;top:var(--fwwb-header-offset);left:0px;width:100%;height:calc(var(--fwwb-header-height) - var(--fwwb-header-offset));background-color:var(--fwwb-header-colour-bg);display:table;';


         let message_element = document.createElement("span");
         message_element.style="display: table-cell;vertical-align: middle;padding-left: 10px;";
         message_element.innerHTML='Remove from "Read later"?';
         wrapper_element.append(message_element);

         let actions_element = document.createElement("span");
         actions_element.style="display: table-cell;vertical-align: middle;padding-left: 10px;text-align: right;padding-right: 10px;min-width: 120px;";

         let confirmation_element = document.createElement("button");
         confirmation_element.innerHTML='Yes';
         confirmation_element.style="width: 50px;"
         confirmation_element.onclick=function(){
           toolbar['readlater'].object_ref.click();
           wrapper_element.remove();
           done_function();
         };
         actions_element.append(confirmation_element);

         let cancel_element = document.createElement("button");
         cancel_element.innerHTML='No';
         cancel_element.style="width: 50px;margin-left: 10px;"
         cancel_element.onclick=function(){
           wrapper_element.remove();
           done_function();
         };
         actions_element.append(cancel_element);

         wrapper_element.append(actions_element);

         let workspace = window.getWorkspace(_this);
         wrapper_element.style.zIndex = parseInt(window.getZIndex(workspace))+1;
         workspace.append(wrapper_element);
        }

        // Speech
        toolbar.speech={};
        toolbar.speech.online=true;
        toolbar.speech.icon='icon-play-circle-fill';
        toolbar.speech.object_ref=true;

        toolbar.speech.onload = async function(_this_element){
          _this_element.classList.add('icon-refresh');
          _this_element.classList.add('icon-spin');
          let audio_component = document.createElement("dsb-audio");
          audio_component.service='text-to-speech';
          audio_component.post_id=post_data.id;
          audio_component.setDSBClient(_this.dsbClient);
          audio_component.setDelegateElement(_this_element);
          if(settings.target=='inline')
          {

            if('setDestructor' in audio_component)
            {
              audio_component.setDestructor(false);
              _this.registeredDistructorFunctions['audio_component']=function(){
                audio_component.setDestructor(true);
              };
            }
            /**
            _this.onEvent('focusLost',function()
            {
              if('action' in audio_component)
              {
                audio_component.action('reset', function(){
                  function__clearState()
                  _this_element.classList.add('icon-play-circle-fill');
                });
              }
            });
            */
          }
          let function__clearState = function(){
            if(_this_element.classList.contains('icon-refresh'))
            {
              _this_element.classList.remove('icon-refresh');
            }
            if( _this_element.classList.contains('icon-spin'))
            {
              _this_element.classList.remove('icon-spin');
            }
            if( _this_element.classList.contains('icon-stop-circle-fill'))
            {
              _this_element.classList.remove('icon-stop-circle-fill');
            }
            if( _this_element.classList.contains('icon-play-circle-fill'))
            {
              _this_element.classList.remove('icon-play-circle-fill');
            }
          }
          let hooks = {};
          hooks.onLoading=function(){
            _this_element.classList.add('icon-refresh');
            _this_element.classList.add('icon-spin');
          };
          hooks.onPlay=function(){
            function__clearState();
           _this_element.classList.add('icon-stop-circle-fill');

          };
          hooks.showPlay=function(){
            function__clearState();
           _this_element.classList.add('icon-stop-circle-fill');

          };
          hooks.onError=function(){
           function__clearState()
           _this_element.classList.add('icon-error');

          };
          hooks.onStop=function(){
           function__clearState()
           _this_element.classList.add('icon-play-circle-fill');
          };
          audio_component.setHooks(hooks);
          if(await audio_component.hasAudio())
          {
            /**
            let _tmp_component = document.createElement("div");
            _tmp_component.id='dsb-audio';
            _tmp_component.style.position='absolute';
            _tmp_component.style.backgroundColor='var(--fwwb-header-colour-bg)';
            _tmp_component.style.height='var(--fwwb-header-height)';
            _tmp_component.style.width='100%';
            _tmp_component.style.top='calc(var(--fwwb-header-offset) + var(--fwwb-header-height));';
            _tmp_component.style.left='0';
            _tmp_component.style.display='inline-block';
            _tmp_component.style.fontSize='';
            _tmp_component.style.zIndex = '99999999999999';
            _tmp_component.append(audio_component);
            */
            _this_element.classList.remove('icon-refresh');
            _this_element.classList.remove('icon-spin');
            _this_element.innerHTML='';
            _this_element.prepend(audio_component);
          }
          else
          {
            _this_element.remove();
          }
          return;
        };

        // Readlater
        toolbar.readlater = {};

        let readlater_function_setIcon = function(responce, _this_element){
          _this.transient_modal__close=false;
          if(_this_element.classList.contains('icon-spin'))
          {
            _this_element.classList.remove('icon-spin');
          }
          if(_this_element.classList.contains('m-icon-loop'))
          {
            _this_element.classList.remove('m-icon-loop');
          }
          if(_this_element.classList.contains('icon-refresh'))
          {
            _this_element.classList.remove('icon-refresh');
          }
          if(_this_element.classList.contains('icon-error'))
          {
            _this_element.classList.remove('icon-error');
          }
          if(_this_element.classList.contains('icon-add-circle'))
          {
            _this_element.classList.remove('icon-add-circle');
          }
          if(_this_element.classList.contains('icon-remove-circle'))
          {
            _this_element.classList.remove('icon-remove-circle');
          }
          if(responce=='pending')
          {
              _this_element.classList.add('icon-refresh');
              _this_element.classList.add('icon-spin');
          }
          else if(responce == 'error')
          {
              _this_element.classList.add('icon-error');
          }
          else if(responce)
          {
              _this_element.classList.add('icon-remove-circle');
              _this.transient_modal__close=transient_modal__close__function;
          }
          else
          {
              _this_element.classList.add('icon-add-circle');
          }
        };

        /**
        let readlater_function_setIcon = function(responce, _this_element){
          if(responce)
          {
              if(_this_element.classList.contains('icon-add-circle'))
              {
                _this_element.classList.remove('icon-add-circle');
              }
              _this_element.classList.add('icon-remove-circle')
          }
          else
          {
            if(_this_element.classList.contains('icon-remove-circle'))
            {
              _this_element.classList.remove('icon-remove-circle');
            }
            _this_element.classList.add('icon-add-circle')
          }
        };
        */

        toolbar.readlater.online=true;
        toolbar.readlater.object_ref=true;
        toolbar.readlater.hook=function(_this_element){
          _this.dsbClient.user.readLater.has(post_data.id,function(result){
            readlater_function_setIcon(result,_this_element);
          })
        };

        toolbar.readlater.click = function(e){
          if(_this.dsbClient.user.readLater)
          {
            let _this_element = this;
            let images = '';
            if('images' in post_data)
            {
              images = post_data.images;
            }

            _this.dsbClient.user.readLater.toggle(post_data.id,post_data.title,images,post_data.excerpt,[],_this.type,_this.service,false,function(responce){

              let has_hooks = (('add_hook' in app) && (typeof app.add_hook == 'function')?true:false);
              readlater_function_setIcon('pending',_this_element);
              switch(responce)
              {
                case "added":
                    window.dispatchEvent(new CustomEvent('fw-workspace-trigger_message', {'detail':{'message':'Added to read later','icon':'done','action':'auto_close-1000'}}));
                    if(!has_hooks)
                    {
                      readlater_function_setIcon(true,_this_element);
                    }
                    break;
                case "removed":
                    window.dispatchEvent(new CustomEvent('fw-workspace-trigger_message', {'detail':{'message':'Removed from read later','icon':'done','action':'auto_close-1000'}}));
                    if(!has_hooks)
                    {
                      readlater_function_setIcon(false,_this_element);
                    }
                    break;
                default:
                    readlater_function_setIcon('error',_this_element);
                    break;
              }
              if(has_hooks)
              {
                app.do_hook('readlater-'+post_data.id);
              }
              _this.doEvent('readLater.toggle',responce);
            });
          }
        };

        try
        {
          if(await _this.dsbClient.user.readLater.has(post_data.id))
          {
            toolbar.readlater.icon = 'icon-remove-circle';
          }
          else
          {
            toolbar.readlater.icon = 'icon-add-circle';
            _this.transient_modal__close=false;
          }
        }
        catch(ex)
        {
          toolbar.readlater.icon = 'icon-circle';
          _this.transient_modal__close=false;
        }

        toolbar.share = {};
        toolbar.share.icon = 'icon-share';
        toolbar.share.dataatts={};
        toolbar.share.dataatts['title']=post_data.title;
        toolbar.share.dataatts['url']= window.location.hostname+post_data.url;
        toolbar.share.dataatts['excerpt']=post_data.excerpt;
        toolbar.share.click = async function(){
          try {
            let title=this.getAttribute('data-title');
            let url=this.getAttribute('data-url');
            let excerpt=this.getAttribute('data-excerpt');
            if('share' in navigator && typeof navigator.share == 'function')
            {
              await navigator
              .share({
                title,
                url,
                excerpt
              });
              window.dispatchEvent(new CustomEvent('dsb-pwa-page_event', {detail:{
                'event_type':'share',
                'data': {
                  'action':'share',
                  'id':post_data.id
                }
              }}));
            }
            else
            {
              var dummy = document.createElement("textarea");
              document.body.appendChild(dummy);
              dummy.value = this.getAttribute('data-url');
              dummy.select();
              document.execCommand("copy");
              document.body.removeChild(dummy);
              window.dispatchEvent(new CustomEvent('fw-workspace-trigger_message', {'detail':{'message':'Ok copied link to clipboard','icon':'done','action':'auto_close-2000'}}));
              window.dispatchEvent(new CustomEvent('dsb-pwa-page_event', {detail:{
                'event_type':'share',
                'data': {
                  'action':'copy',
                  'id':post_data.id
                }
              }}));
            }

          } catch (err) {
            _this._log('error','toolbar.share.click',err);
          }
        };


        // options
        toolbar.options={};
        toolbar.options.online=false;
        toolbar.options.icon='m-icon-system-settings';
        toolbar.options.object_ref=true;

        let options={};
        let content_preferences_fontsize = await _this.dsbClient.user.custom_settings.get_setting('content_preferences_fontsize');
        if(typeof content_preferences_fontsize == 'object' && content_preferences_fontsize!=null && 'getBody' in content_preferences_fontsize)
        {
          options['font-size']={};
          options['font-size'].name="Font size";
          options['font-size'].desc="<small>Note: Size changes apply to all articles</small>";
          options['font-size'].getBody=content_preferences_fontsize.getBody;
        }

        toolbar.options.click = async function(_this_element){

          let options_tool=_this_element.currentTarget;

          if(('fw_workbench__closeOptions' in options_tool) && typeof options_tool.fw_workbench__closeOptions=='function')
          {
            options_tool.fw_workbench__closeOptions();
          }
          else
          {
            let options_html = document.createElement("div");
            let options_title = document.createElement("h3");
            options_title.innerHTML='Read options';
            options_title.style="text-align:center;";
            options_html.append(options_title);
            let options_ul = document.createElement("ul");
            for(let anOption in options)
            {
              if(('name' in options[anOption]) && ('getBody' in options[anOption]) && (typeof options[anOption].getBody == 'function'))
              {
                let option_li = document.createElement("li");
                option_li.innerHTML='<h3>'+options[anOption].name+'</h3><p>'+options[anOption].desc+'</p>';
                let thisBody=options[anOption].getBody();
                if(typeof thisBody == 'object' && thisBody instanceof HTMLElement)
                {
                  option_li.append(thisBody);
                }
                else
                {
                  option_li.innerHTML=option_li.innerHTML+options[anOption].body;
                }

                options_ul.append(option_li);
              }
            }
            options_html.append(options_ul);

            window.dispatchEvent(new CustomEvent('dsb-pwa-transient_aside', {detail:{
                body:options_html,
                name: post_data.id+'_options_'+_this.uuid,
                iam: options_tool
              }}));
          }

        }

        toolbar.top = {};
        toolbar.top.align = 'left';
        toolbar.top.object_ref=true;
        toolbar.top.icon = 'icon-up';
        toolbar.top.click = function(){
          let workspace = window.getWorkspace(_this.parentNode);
          if(('fw_workbench' in window) && ('smoothScroll' in window.fw_workbench) && ('getAppStyleProperties' in window.fw_workbench))
          {
            let scroll_to = parseInt(_this.getBoundingClientRect().top)-parseInt(window.fw_workbench.getAppStyleProperties('header','height').replace('px',''))-parseInt(getComputedStyle(document.documentElement).getPropertyValue("--safe-top"));
            window.fw_workbench.smoothScroll(workspace,scroll_to);
          }
        };

        let toolbarEventComponent = document.createElement("span");
        toolbarEventComponent.style="display:inline-block;position:relative;width:100%;height:3em;background-color:transparent;";

        let toolbarComponent = document.createElement("div");
        let toolbarComponent_id = this._createUUID();
        toolbarComponent.id = toolbarComponent_id;
        toolbarComponent.classList.add('dsb-post-toolbar');
        toolbarComponent.style="position:absolute;top:0px;width:100%;background-color:transparent;height:3em;";


        let toolbarComponent_left = document.createElement("div");
        toolbarComponent_left.classList.add('left');
        toolbarComponent_left.style.display='none';
        let toolbarComponent_right = document.createElement("div");
        toolbarComponent_right.classList.add('right');

        for(let item in toolbar)
        {
          let _tmp_component = document.createElement("span");
          _tmp_component.id = this.uuid+'__'+item;
          _tmp_component.classList.add(item);
          _tmp_component.classList.add('icon-clickable');
          _tmp_component.classList.add(toolbar[item].icon);

          if('onload' in toolbar[item] && typeof toolbar[item].onload === 'function')
          {
            toolbar[item].onload(_tmp_component);
          }

          if('click' in toolbar[item] && typeof toolbar[item].click === 'function')
          {
            _tmp_component.onclick=toolbar[item].click;
          }

          if('online' in toolbar[item])
          {
            _tmp_component.classList.add('fw_workspace__online_only');
            _tmp_component.setAttribute('data-offlineonly_toggleClass','offline');
          }

          if('hook' in toolbar[item])
          {
            if('add_hook' in app && typeof app.add_hook == 'function')
            {
              app.add_hook(this.uuid,item+'-'+post_data.id,toolbar[item].hook,_tmp_component);
            }
          }

          if('dataatts' in toolbar[item])
          {
            for(let _dataatts in toolbar[item].dataatts)
            {
              _tmp_component.setAttribute('data-'+_dataatts,toolbar[item].dataatts[_dataatts]);
            }
          }

          if('object_ref' in toolbar[item] && toolbar[item].object_ref)
          {
            toolbar[item].object_ref = _tmp_component;
          }

          if('target' in settings && settings.target=='header')
          {
            _tmp_component.style.fontSize='25px';
            if('align' in toolbar[item] && toolbar[item].align == 'left')
            {
              window.dispatchEvent(new CustomEvent('dsb-pwa-append_tray', {detail:{
                name: item,
                element:_tmp_component,
                iam:this,
                tray_selector:'.tray_left',
                dom_insertion:'append'
              }}));
            }
            else
            {
              window.dispatchEvent(new CustomEvent('dsb-pwa-append_tray', {detail:{
                name: item,
                element:_tmp_component,
                iam:this,
                dom_insertion:'append'
              }}));
            }
          }
          else
          {
            if('align' in toolbar[item] && toolbar[item].align == 'left')
            {
              toolbarComponent_left.append(_tmp_component);
            }
            else
            {
              toolbarComponent_right.append(_tmp_component);
            }
          }
        }

        if('target' in settings)
        {
          if(settings.target=='header')
          {
            toolbar['top'].object_ref.style.display='none';

            let previousY = 0
            let previousRatio = 0
            let toolbarComponentScrollObserver = new IntersectionObserver(function(entries, observer) {
              entries.forEach(function(entry) {
                  let toTop = false;
                  const currentY = entry.boundingClientRect.y;
                  const currentRatio = entry.intersectionRatio;

                  if (entry.isIntersecting == 0) {
                    toTop=true;
                  }

                  //console.error('@entry.isIntersecting',entry.isIntersecting, toolbar['top'].object_ref);

                  if(_this.style.display=='none')
                  {
                    toTop=false;
                  }

                  if(currentY>previousY)
                  {
                    toTop=false;
                  }

                  if(toTop)
                  {
                   if(toolbar['readlater'].object_ref.classList.contains('icon-remove-circle'))
                   {
                      _this.transient_modal__close=transient_modal__close__function;
                   }
                  }
                  else
                  {
                    // OK, dont care
                  }

                  previousY = currentY;
                  previousRatio = currentRatio;
              });
            },{threshold:0.25});
            toolbarEventComponent.style="display:inline-block;position:absolute;width:100%;height:3em;background-color:transparent;top:100px";
            toolbarComponentScrollObserver.observe(toolbarEventComponent);
            _this.prepend(toolbarEventComponent);

          }
          else
          {
            toolbarComponent.append(toolbarComponent_left);
            toolbarComponent.append(toolbarComponent_right);

            let previousY = 0
            let previousRatio = 0
            let was_toolbarComponent_left__display = toolbarComponent_right.style.display;
            let was_toolbarComponent__zindex = toolbarComponent.style.zIndex;

            let toolbarComponentScrollObserver = new IntersectionObserver(function(entries, observer) {
              entries.forEach(function(entry) {
                  let toTop = false;
                  const currentY = entry.boundingClientRect.y;
                  const currentRatio = entry.intersectionRatio;

                  if (entry.isIntersecting == 0) {
                    toTop=true;
                  }

                  if(_this.style.display=='none')
                  {
                    toTop=false;
                  }

                  if(currentY>previousY)
                  {
                    toTop=false;
                  }

                  if(toTop)
                  {
                    if(toolbarComponent.parentNode ==  _this)
                    {
                      app.appendChild(_this.removeChild(toolbarComponent));
                      toolbarComponent.style.backgroundColor='var(--fwwb-header-colour-bg)';
                      toolbarComponent.style.top='var(--fwwb-header-offset)';
                      toolbarComponent_left.style.display=was_toolbarComponent_left__display;
                      toolbarComponent_right.style.fontSize='';
                      toolbarComponent.style.zIndex = '99999999999999';
                      window.dispatchEvent(new CustomEvent('dsb-pwa-toggle_furniture', {'detail':{'target':'tabs','show':false}}));
                    }
                  }
                  else
                  {
                    if(toolbarComponent.parentNode ==  app)
                    {
                      _this.prepend(app.removeChild(toolbarComponent));
                      toolbarComponent.style.backgroundColor='transparent';
                      toolbarComponent.style.top='0px';
                      toolbarComponent_left.style.display='none';
                      toolbarComponent_right.style.fontSize='15px';
                      toolbarComponent.style.zIndex = parseInt(window.getZIndex(toolbarEventComponent))+1;
                      window.dispatchEvent(new CustomEvent('dsb-pwa-toggle_furniture', {'detail':{'target':'tabs','show':true}}));
                    }
                  }

                  previousY = currentY;
                  previousRatio = currentRatio;
              });
            },{threshold:0.25});

            toolbarComponentScrollObserver.observe(toolbarEventComponent);
            this.registeredDistructorFunctions['toolbarComponentScrollObserver']=function(){
              if(toolbarEventComponent instanceof HTMLElement)
              {
                if(toolbarComponent.parentNode ==  app)
                {
                  _this.prepend(app.removeChild(toolbarComponent));
                  toolbarComponent.style.backgroundColor='transparent';
                  toolbarComponent.style.top='0px';
                  toolbarComponent_left.style.display='none';
                  toolbarComponent_right.style.fontSize='15px';
                  toolbarComponent.style.zIndex = parseInt(window.getZIndex(toolbarEventComponent))+1;
                  window.dispatchEvent(new CustomEvent('dsb-pwa-toggle_furniture', {'detail':{'target':'tabs','show':true}}));
                }
              }
            };
            this.registeredListners.push({'type':'IntersectionObserver','object':toolbarComponentScrollObserver});

            _this.prepend(toolbarComponent);
            _this.prepend(toolbarEventComponent);
          }
        }
      }
     }

  }

  _show_header_nav()
  {
      // Setup post toolbar
      let list_items = [];
      let header_tray = document.createElement("li");
      header_tray.classList.add('tray');
      header_tray.append(this._get_toolbar());
      list_items.push(header_tray);
      window.dispatchEvent(new CustomEvent('fw-workspace-set_header_overlay', {detail: {iam:this,'list_items':list_items}}));
  }

  async _render()
  {
    let settings = this.settings;

    if(this.classList.contains('fw_workspace__online_only'))
    {
       this.classList.remove('fw_workspace__online_only');
    }

    try
    {

      if(typeof settings === 'object' && settings !== null)
      {
        if(!('internal_links' in settings))
        {
          settings.internal_links = 'new_window';
        }
        if(!('page_view_onload' in settings))
        {
          settings.page_view_onload = 'on';
        }
        if(!('pulldown_refresh' in settings))
        {
          settings.pulldown_refresh = 'on';
        }
        if(!('lazy_images' in settings))
        {
          settings.lazy_images = 'on';
        }
      }
      else
      {
        settings = {};
        settings.internal_links = 'new_window';
        settings.page_view_onload = 'on';
        settings.pulldown_refresh = 'on';
        settings.lazy_images = 'on';
      }


      if(!('title' in settings))
      {
        settings.title = 'default';
      }

      if(!this.is_refresh)
      {
        this.innerHTML = `<maa-spinner></maa-spinner>`;
      }

      //let img_path = `https://stmaadev.blob.core.windows.net/stc-maa-dev-fw-site`;
      //let img_path = `https://stmaaprodfwsite.blob.core.windows.net/assets`;

      let img_path = ``;

      if(this.post_data === undefined || this.post_data.length == 0)
      {
        if(this.post_id && this.service)
        {
          let json = await this.dsbClient.content.get(this.service,await this.getPostIdEndpoint(),true);
          if (json.state)
          {
            this.post_data = json.data;
          }
        }
      }


      if(`image_path` in this.dsbClient.content)
      {
        img_path = this.dsbClient.content.image_path;
      }


      if(this.post_data === undefined || this.post_data.length < 0)
      {
        this.innerHTML = `<article class="error-500" role="article">
          <p>501 :(</p>
          <p>Something seems to have gone wrong...</p>
        </article>`;
      }
      else
      {

        let modal_mode = true;
        var body_modal_panel_id = `dsb-modal-workspace-`+this._createUUID();

        if(this.post_data.length > 0)
        {
            // Some API data found, but *could* be 404 - 0 results!
            let html,template,format,result  = ``;

            var nav_panel = document.createElement("nav");
            var nav_panel_tabs = document.createElement("ul");
            var nav_parent_id = '';

            var section_panel = document.createElement("section");
            var footer_panel = document.createElement("section");
            footer_panel.setAttribute(`class`, `footer`);

            var body_panel = document.createElement("article");
            body_panel.setAttribute(`class`, `post`);
            body_panel.setAttribute(`role`, `article`);
            body_panel.setAttribute(`itemscope`, ``);
            body_panel.setAttribute(`itemtype`, `http://schema.org/NewsArticle`);

            this.page_view_settings = {};

            // Only grab 1st TODO allow more than one article
            for (let i = 0; i < 1; i++)
            {
              let this_post = this.post_data[i];

              if('document' in this.post_data[i])
              {
                this_post = this.post_data[i].document;
              }

              if(`settings` in this_post)
              {
                for(let this_post_settings__key in this_post.settings)
                {
                  settings[this_post_settings__key]=this_post.settings[this_post_settings__key];
                }
              }

              if(!(`header` in settings))
              {
                settings.header='on';
              }

              if(!(`author` in settings))
              {
                settings.author='on';
              }

              if(!(`base_update` in settings))
              {
                settings.base_update='off';
              }

              if(('pulldown_refresh' in settings) && (settings.pulldown_refresh == 'on'))
              {
                if(!this.is_refresh)
                {
                  window.dispatchEvent(new CustomEvent('dsb-pwa-add_pulldown_refresh', {detail: {iam: this}}));
                }
              }

              this.page_view_settings = {};
              this.page_view_settings.id=this_post.id;
              this.page_view_settings.date=this.dsbClient.content.format_date(this_post.created_date,'Y-m-d');
              this.page_view_settings.title = this_post.title;
              this.page_view_settings.taxonomies = [];
              this.page_view_settings.types = [];
              this.page_view_settings.customDimensions = {};
              this.page_view_settings.author = '';

              let post_type = this_post.type;

              if(this.post_type && this.post_type.length > 0)
              {
                post_type = this.post_type;
              }

              if(`post` == post_type)
              {
                section_panel.setAttribute(`class`, `page-width`);
                this.page_view_settings.types.push('article');
              }
              else
              {
                body_panel.setAttribute(`class`, `page`);

                if(['fw_dsb_app_tab'].indexOf(post_type) != -1)
                {
                  if('base_update' in settings && settings['base_update']=='on')
                  {
                    let base_update_detail = {appname:this_post.title};
                    if('override_title' in settings)
                    {
                      base_update_detail.appname=settings.override_title;
                    }

                    if('flag_beta' in settings && settings.flag_beta=='on')
                    {
                      base_update_detail.appname+='<span style="color:red;font-size:9px;vertical-align:super;padding-left:5px;">beta</span>';
                    }

                    window.dispatchEvent(new CustomEvent('dsb-pwa-base_update', {detail:base_update_detail}));
                  }

                  delete this.page_view_settings.title;
                  this.page_view_settings.customDimensions.contenttitle = this_post.title;
                  this.page_view_settings.types.push('app_tab');
                }
                else
                {
                  this.page_view_settings.types.push(post_type);
                }
              }

              let primary_cat = '';
              if('taxonomies' in this_post)
              {
                if('category' in this_post.taxonomies)
                {
                  let primary_root_cat_slug=false;
                  if('primary_root_id' in this_post.taxonomies.category)
                  {
                    let primary_root_cat = await this.dsbClient.content.applyAsyncFilter(`formatData_lookup`, [ `all_cat_obj`, this_post.taxonomies.category.primary_root_id ] );
                    if(typeof primary_root_cat === 'object' && primary_root_cat !== null && 'slug' in primary_root_cat)
                    {
                      primary_root_cat_slug=primary_root_cat.slug;
                    }
                  }
                  if('primary_id' in this_post.taxonomies.category)
                  {
                    primary_cat = await this.dsbClient.content.applyAsyncFilter(`formatData_lookup`, [ `all_cat_obj`, this_post.taxonomies.category.primary_id ] );
                    if(typeof primary_cat === 'object' && primary_cat !== null && 'slug' in primary_cat)
                    {
                      primary_cat = primary_cat.slug;
                      if(!primary_root_cat_slug)
                      {
                        section_panel.classList.add(primary_cat+'-category-col');
                      }
                      else
                      {
                        section_panel.classList.add(primary_root_cat_slug+'-category-col');
                      }
                      //this.page_view_settings.sitesection2 = primary_cat;

                      if('list' in this_post.taxonomies.category)
                      {
                        //let sitesection_count = 2;
                        for(let list_item in this_post.taxonomies.category.list )
                        {
                          let acat = await this.dsbClient.content.applyAsyncFilter(`formatData_lookup`, [ `all_cat_obj`, this_post.taxonomies.category.list[list_item] ] );
                          if(typeof acat === 'object' && acat !== null && 'slug' in acat)
                          {
                            //this.page_view_settings['sitesection'+sitesection_count] = acat.slug;
                            this.page_view_settings.taxonomies.push(acat.slug);
                            //sitesection_count++;
                          }
                        }
                      }
                    }
                  }
                }
                if('article_type' in this_post.taxonomies)
                {
                  if('list' in this_post.taxonomies.article_type)
                  {
                    for(let list_item in this_post.taxonomies.article_type.list )
                    {
                      let acat = await this.dsbClient.content.applyAsyncFilter(`formatData_lookup`, [ `all_cat_obj`, this_post.taxonomies.article_type.list[list_item] ] );
                      if(typeof acat === 'object' && acat !== null && 'slug' in acat)
                      {
                        //this.page_view_settings.contenttype += "|"+acat.slug;
                        this.page_view_settings.types.push(acat.slug);
                      }
                    }
                  }
                }
              }


              let body = document.createElement("div");

              let title = null;

              switch(post_type)
              {
                  case "post":
                        console.log(`Loading `+post_type+`....`);
                        if(settings.header && settings.header=='on')
                        {
                          title = document.createElement("h1");
                          title.setAttribute(`itemprop`,`headline`);
                          title.innerHTML = this_post.title;
                          body_panel.append(title);
                          body.setAttribute(`itemprop`,`articleBody`);

                          // Header Image
                          if('images' in this_post)
                          {
                            try
                            {
                              let has_image = true;
                              if(('metadata' in this_post)
                                && (typeof this_post.metadata == 'object')
                                && ('hide_featured_image' in this_post.metadata)
                                && this_post.metadata.hide_featured_image=='on')
                              {
                                has_image=false;
                              }

                              if(has_image && ('large' in this_post.images))
                              {
                                  let header_image = document.createElement("div");
                                  header_image.classList.add('featured-image');
                                  let header_image_image = document.createElement("img");
                                  header_image_image.src = this_post.images['large'];
                                  header_image.append(header_image_image);
                                  body_panel.append(header_image);
                              }
                            }
                            catch(ex)
                            {
                              this._log('error','_render','Error processing images',{'error':ex,'data':this_post});
                            }
                          }
                        }
                        break;
                  case "fw_dsb_app_tab":
                        console.log(`Loading `+post_type+`....`);
                        settings.toolbar='off';

                        if(settings.header && settings.header=='on')
                        {
                          title = document.createElement("h1");
                          title.setAttribute(`itemprop`,`headline`);
                          title.innerHTML = this_post.title;
                          body_panel.append(title);
                        }
                        break;
                  default:
                        console.log(`Loading `+post_type+`....`);
                        break;
              }
              body.innerHTML = ``;

              // Set Author
              let author_name = '';
              let advertiser_section = null;
              try
              {
                if('author' in this_post)
                {
                  if('name' in this_post.author)
                  {
                    author_name = this_post.author.name;
                  }


                  if('id' in this_post.author)
                  {
                    author_name = await this.dsbClient.content.applyAsyncFilter(`formatData_lookup`, [ `authors`, this_post.author.id ] );
                    if('name' in author_name)
                    {
                      author_name = author_name.name;
                    }
                    else
                    {
                      author_name = 'missing';
                    }

                     // Highlite adverts
                    if('type' in this_post.author)
                    {
                      switch(this_post.author.type)
                      {
                        case "advert":
                            settings.author = 'off';
                            section_panel.classList.add('advertiser');
                            section_panel.classList.add('advertiser-category-col');
                            let advert_header = document.createElement('h3');
                            advert_header.classList.add('advert-header');
                            advert_header.innerHTML = 'Advertiser content';
                            this.classList.add('advert-background');
                            section_panel.prepend(advert_header);

                            try
                            {
                              let this_advertiser = await this.dsbClient.content.get('static','json_by_id/'+this_post.author.id,true);
                              if (this_advertiser.state=='success')
                              {
                                if(typeof this_advertiser === 'object' && this_advertiser !== null && ('data' in this_advertiser) &&  this_advertiser.data.length > 0)
                                {
                                  this_advertiser = this_advertiser.data[0];
                                  advertiser_section = document.createElement('div');
                                  advertiser_section.classList.add('advertiser-content-wrap');
                                  advertiser_section.innerHTML='<h4>Provided by '+this_advertiser.name+'</h4><span class="border-bottom"></span>';
                                  let advertiser_content = document.createElement('div');
                                  advertiser_content.classList.add('advertiser-content');
                                  /**
                                  let advertiser_logo_img = this.dsbClient.content.applyFilter(`formatData_lookup`, [ `author_advertiser_logo`, this_advertiser.id ] );
                                  if(advertiser_logo_img)
                                  {
                                    let advertiser_logo = document.createElement("div");
                                    advertiser_logo.classList.add('circle-image');
                                    advertiser_logo.setAttribute('style','background-image:url('+advertiser_logo_img+')');
                                    //advertiser_logo.classList.add('circle-image');
                                    advertiser_content.append(advertiser_logo);
                                  }
                                  */

                                  if('excerpt' in this_advertiser)
                                  {
                                    let advertiser_description = document.createElement('div');
                                    advertiser_description.innerHTML = this_advertiser.excerpt;
                                    advertiser_content.append(advertiser_description);
                                  }
                                  else if('body' in this_advertiser)
                                  {
                                    let advertiser_description = document.createElement('div');
                                    advertiser_description.innerHTML = this_advertiser.body;
                                    advertiser_content.append(advertiser_description);
                                  }
                                  advertiser_section.append(advertiser_content);
                                  body_panel.append(advertiser_section);

                                }
                                else
                                {
                                  this._log('error','_render','Missing this_advertiser object',this_advertiser);
                                }
                              }
                            }
                            catch(ex)
                            {
                              this._log('error','_render','Problem with advertiser details',ex);
                            }

                            /**
                            let advertiser_logo_img = this.dsbClient.content.applyFilter(`formatData_lookup`, [ `author_advertiser_logo`, this_post.author.id ] );
                            let advertiser_logo = document.createElement("div");
                            advertiser_logo.setAttribute('style','background-image:url('+advertiser_logo_img+')');
                            advertiser_logo.classList.add('circle-image');
                            */
                            break;
                        default:
                            break;
                      }
                    }
                  }

                  if(author_name.length > 0)
                  {
                    this.page_view_settings.author = author_name;

                    if(settings.author == 'on')
                    {
                      let author_description = document.createElement('div');
                      author_description.classList='author-metadata';
                      let author_description_name = document.createElement('div');
                      author_description_name.classList='author-name';
                      author_description_name.innerHTML = 'By '+author_name;
                      author_description.append(author_description_name);
                      body_panel.append(author_description);
                    }
                  }
                }
              }
              catch(ex)
              {
                this._log('error','_render','Missing author name, may need to refresh lookup',ex);

              }



              //this.page_view_settings.contenttype=post_type;


              let has_widgets = false;
              if(`post_widgets` in this_post)
              {
                has_widgets = this._generate_post_widgets(this_post.post_widgets, body);
              }

              if(!has_widgets)
              {
                if(`content` in this_post)
                {
                    if(!has_widgets)
                    {
                        if(`rendered` in this_post.content)
                        {
                          body.innerHTML = this_post.content.rendered;
                        }
                        else
                        {
                          console.warn('Missing document.content.rendered');
                        }
                    }
                }
                else
                {
                    console.warn('Missing document.content', this_post);
                }
              }


              if(`clean_body` in settings && settings.clean_body !== 'off')
              {
                 var attr = [
                    'align',
                    'background',
                    'bgcolor',
                    'color',
                    'face',
                    'height',
                    'hspace',
                    'marginheight',
                    'marginwidth',
                    'noshade',
                    'nowrap',
                    'valign',
                    'vspace',
                    'width',
                    'vlink',
                    'alink',
                    'text',
                    'link',
                    'frame',
                    'frameborder',
                    'clear',
                    'scrolling',
                    'style/background-image'
                 ];
                if(settings.clean_body == 'full')
                {
                  attr = [
                    'align',
                    'background',
                    'bgcolor',
                    'border',
                    'cellpadding',
                    'cellspacing',
                    'color',
                    'face',
                    'height',
                    'hspace',
                    'marginheight',
                    'marginwidth',
                    'noshade',
                    'nowrap',
                    'valign',
                    'vspace',
                    'width',
                    'vlink',
                    'alink',
                    'text',
                    'link',
                    'frame',
                    'frameborder',
                    'clear',
                    'scrolling',
                    'style'
                  ];
                }
                let function__parseAtts = function(all,attr) {
                  var i = all.length;
                  var j, is_hidden;

                  // Presentational attributes.


                  var attr_len = attr.length;

                  while (i--) {
                    is_hidden = (all[i].style.display === 'none');

                    j = attr_len;

                    while (j--) {
                      if(attr[j] == 'style/background-image')
                      {
                        if(all[i].style.backgroundImage.length>0)
                        {
                          let thisbackgroundImage = all[i].style.backgroundImage.slice(5, -2).replace(/"/g, "");
                          if(thisbackgroundImage.indexOf("http") == -1)
                          {
                            all[i].style.backgroundImage = `url(`+img_path+thisbackgroundImage+`)`;
                          }
                        }
                      }
                      else
                      {
                        all[i].removeAttribute(attr[j]);
                      }
                    }

                    // Re-hide display:none elements,
                    // so they can be toggled via JS.
                    if (is_hidden) {
                      all[i].style.display = 'none';
                      is_hidden = false;
                    }
                  }
                };
                function__parseAtts(body.getElementsByTagName('*'),attr);
              }

              body_panel.append(body);

              result = true;
            }

            if(result)
            {
              // Add body
              section_panel.append(body_panel);

              this.innerHTML = ``;
              if(`background-color` in settings)
              {
                this.style.backgroundColor=settings['background-color'];
              }
              //this.append(nav_panel);
              this.append(section_panel);

              // Execute any scripts in section_panel
              Array.from(this.querySelectorAll("script")).forEach( oldScript => {
                const newScript = document.createElement("script");
                Array.from(oldScript.attributes)
                  .forEach( attr => newScript.setAttribute(attr.name, attr.value) );
                newScript.appendChild(document.createTextNode(oldScript.innerHTML));
                oldScript.parentNode.replaceChild(newScript, oldScript);
              });

              // Append body
              for(let i = 0; i < this.append_content.length; i++)
              {
                if(this.append_content[i] instanceof HTMLElement)
                {
                  this.append(this.append_content[i]);
                }
                else
                {
                  let appended_content_element = document.createElement("div");
                  appended_content_element.innerHTML = this.append_content[i];
                  this.append(appended_content_element);
                }
              }

              try
              {
                let a = this.querySelectorAll("a");
                if(a !== undefined || a.length > 0)
                {
                  switch(settings.internal_links)
                  {
                    case "modal":
                          const on_click = function() {
                            let target_id = this.getAttribute("data-target");
                            let target_type = this.getAttribute("data-target-type");
                            let query = this.getAttribute("data-query");
                            let service = this.getAttribute("data-service");

                            if(target_id)
                            {
                              let target =  document.getElementById(target_id);
                              if(target)
                              {
                                target.setAttribute('query', query);
                                target.setAttribute('service', service);
                              }
                              else
                              {
                                console.log('NO TRAGET');
                              }

                              if('dsb-modal' == target_type)
                              {
                                document.querySelector('dsb-modal').classList.toggle('show');
                              }
                            }
                            else
                            {
                              console.log('DSBSections missing ID');
                            }
                          };

                          for(let i = 0; i < a.length; i++)
                          {
                            a[i].setAttribute(`data-target`, ``+body_modal_panel_id);
                            a[i].setAttribute(`data-target-type`, `dsb-modal`);
                            a[i].setAttribute(`data-query`,`url=`+a[i].getAttribute('href'));
                            a[i].setAttribute(`data-service`,`post`);
                            a[i].setAttribute(`href`,`javascript:return;`);
                            a[i].onclick = on_click;
                          }
                          break;
                    default:
                          for(let i = 0; i < a.length; i++)
                          {

                            let href = a[i].getAttribute('href').trim();
                            a[i].setAttribute(`target`, `_blank`);

                            if(href.indexOf("#") == 0)
                            {
                              a[i].setAttribute(`data-internal_link`, href.substring(1));
                              a[i].onclick = function(){
                                var elem = document.getElementById(this.getAttribute('data-internal_link'));
                                elem.scrollIntoView();
                              };
                              a[i].setAttribute(`href`,`javascript:return;`);
                              a[i].setAttribute(`target`, `_self`);
                            }
                            else if(href.indexOf("http") == -1)
                            {
                              // check for documents
                              let extension = href.split('.');
                              if(extension.length > 1 && (extension[1] !== 'htm' && extension[1] !== 'html'))
                              {
                                a[i].setAttribute(`href`,img_path+href);
                              }
                              else
                              {
                                a[i].setAttribute(`href`,window.location.origin+href);
                              }
                            }

                          }
                          break;

                  }
                }

                let img = this.querySelectorAll("img");

                if(img !== undefined || img.length > 0)
                {
                  for(let i = 0; i < img.length; i++)
                  {
                    if(settings.lazy_images == 'on')
                    {
                      img[i].setAttribute(`loading`,'lazy');
                    }
                    else
                    {
                      //img[i].setAttribute(`loading`,'eager');
                    }
                    let src = img[i].getAttribute('src');
                    if(src.indexOf("http") == -1)
                    {
                      img[i].setAttribute(`src`,img_path+src);
                    }
                  }
                }

                // Add table-wrapper
                let tables = this.querySelectorAll("table");
                if(tables !== undefined || tables.length > 0)
                {
                  for(let i = 0; i < tables.length; i++)
                  {
                    tables[i].outerHTML = '<div class="scroll-wrapper">'+tables[i].outerHTML+'</div>';
                  }
                }



                // Set appends
                for(let i = 0; i < this.footer.length; i++)
                {
                    footer_panel.append(this.footer[i]);
                }

                if(footer_panel.childNodes.length > 0)
                {
                  this.append(footer_panel);
                }

                if(settings.page_view_onload=='on')
                {
                  this.page_view();
                }

                if('toolbar' in settings)
                {
                  if(settings.toolbar!=='off')
                  {
                    if(!(typeof settings.toolbar === 'object') || !('target' in settings.toolbar))
                    {
                      settings.toolbar={};
                      settings.toolbar.target='inline';
                    }
                    this._setup_toolbar(settings.toolbar);
                  }
                }

              }
              catch(ex)
              {
                console.log(ex);
              }

              return;
            }

            this.innerHTML = `Missing post`;
        }
        else
        {
          throw {code:404,message:'No results',data:this.post_data};
        }
      }
    }
    catch(ex)
    {
      let code = 500;
      let message = '';
      if(typeof ex === 'object' && ex !== null && ('code' in ex))
      {
        code = ex.code;
        if('message' in ex)
        {
          message = ex.message;
        }
      }
      let is_offline = await this.dsbClient.user.is_offline(false,true);

      if(is_offline=='maintenance')
      {
        code = 'maintenance';
      }
      else if(is_offline)
      {
        code = 503;
      }

      if('result' in ex && 'message' in ex.result && ex.result.message == 'NetworkError when attempting to fetch resource.')
      {
        code = 503;
      }


      switch(code+"")
      {
        case "403":
          this.innerHTML = `<article class="error-404" role="article">
            <p>Access denied</p>
            <p>`+message+`<br/></p>
          </article>`;
          break;
        case "404":
          this.innerHTML = `<article class="error-404" role="article">
            <p>404 :(</p>
            <p>We can't seem to find this page.</p>
          </article>`;
          break;
        case "503":
          this.innerHTML = `<article class="error-90" role="article">
            <p>Offline</p>
            <p>Sorry, offline version not available.<br/>Please try again later when you have an internet connection :)</p>
          </article>`;
          this.classList.add('fw_workspace__online_only');
          break;
        case "maintenance":
          this.innerHTML = `<article class="error-503" role="article">
            <p>Maintenance work ongoing...</p>
            <p>Sorry we are currently performing maintenance please <a href="javascript:return;" onclick="window.location.reload(false);">click here</a> to try again or check back later.</p>
          </article>`;
          break;
        default:
          this.innerHTML = `<article class="error-500" role="article">
                <p>Sorry an error has occured.</p>
                <p>
                  Please try again by <a href="javascript:return;" onclick="window.location.reload(true);">clicking here</a> or try again later.
                </p>
                <details>
                  <summary>Details</summary>
                  <div>
                   is_offline:`+is_offline+`<br/>
                   From dsb-post:<br/>
                    `+JSON.stringify(ex)+`
                  </div>
                </details>
              </article>`
          console.error(ex);
          break;
      }
    }

     window.dispatchEvent(new CustomEvent('fw-workspace-offline_status'));
    return;
  }
}


